<div class="sign-content-container">
    <div #iframe id="iframe" class="iframe"></div>
    <div class="details">
        <h3>{{ this.signRequest.request_name }}</h3>
        <h4>{{ this.signRequest.document?.status }}</h4>
        <p>
            Drag and drop the signature and other fill-in fields into the document on the right.
        </p>
        <p>
            When ready, click the Send button on top and choose Send Document
        </p>
    </div>
</div>
